/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { Add } from "@mui/icons-material";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getLentesContacto } from "../../services/LenteContactoService";
import { getCacheData } from "../../services/CacheService";
import { limpiaCodigo } from "../../utils/utils";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";
import { formatMoney } from "../../utils/utils";

const initialSearchData = {
  codigo: "",
  modelo: "",
  descripcion: "",
  codigoExterno: "",
  idLcProducto: null,
  idLcPresentacion: null,
  idLcCurva: null,
  idLcDiametro: null,
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Lentes de Contacto";
//
// #############################################################################
//
const LenteContactoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [lcDiametros, setLcDiametros] = useState([]);
  const [lcPresentaciones, setLcPresentaciones] = useState([]);
  const [blCurvas, setBlCurvas] = useState([]);
  const [LentesContactoProductos, setLentesContactoProductos] = useState([]);
  const navigate = useNavigate();
  const [valueACBlCurva, setValueACBlCurva] = useState(null);
  const [inputValueACBlCurva, setInputValueACBlCurva] = useState("");
  const [valueACLcDiametro, setValueACLcDiametro] = useState(null);
  const [inputValueACLcDiametro, setInputValueACLcDiametro] = useState("");
  const [valueACLcPresentacion, setValueACLcPresentacion] = useState(null);
  const [inputValueACLcPresentacion, setInputValueACLcPresentacion] = useState("");
  const [valueACLenteContactoProducto, setValueACLenteContactoProducto] = useState(null);
  const [inputvalueACLenteContactoProducto, setInputvalueACLenteContactoProducto] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearLenteContacto = hasPermission("lente-contacto-c");
  const _editarLenteContacto = hasPermission("lente-contacto-e");
  const _habilitarLenteContacto = hasPermission("lente-contacto-h");
  const _deshabilitarLenteContacto = hasPermission("lente-contacto-d");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "modelo",
      headerName: "Modelo",
      headerAlign: "center",
      align: "left",
      flex: 6,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.modelo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "valor_lc_curva",
      headerName: "Curva",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.valor_lc_curva);
      },
    },
    {
      field: "valor_lc_diametro",
      headerName: "Diámetro",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.valor_lc_diametro);
      },
    },
    {
      field: "esfera",
      headerName: "Esfera",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera);
      },
    },
    {
      field: "cilindro",
      headerName: "Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro);
      },
    },
    {
      field: "eje",
      headerName: "Eje",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return params.row.eje;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarLenteContacto && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
          {params.row.habilitado && _deshabilitarLenteContacto && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
          {!params.row.habilitado && _habilitarLenteContacto && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  // 
  useEffect(() => {
    loadLentesContactoProductos();
    loadLcPresentaciones();
    loadBlCurvas();
    loadLcDiametros();
  }, []);
  //
  // ################################################################################
  // 
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setItemsCrud([]);
    setValueACLcPresentacion(null);
    setInputValueACLcPresentacion("");
    setValueACBlCurva(null);
    setInputValueACBlCurva("");
    setValueACLcDiametro(null);
    setInputValueACLcDiametro("");
    setValueACLenteContactoProducto(null);
    setInputvalueACLenteContactoProducto("");
    setValueACLenteContactoProducto(null);
    setInputvalueACLenteContactoProducto("");
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setSearchData({
      ...searchData,
      codigo: limpiaCodigo(searchData.codigo).toUpperCase(),
      codigoExterno: limpiaCodigo(searchData.codigoExterno).toUpperCase()
    });

    let _params = {
      codigo: searchData.codigo,
      descripcion: searchData.descripcion,
      modelo: searchData.modelo,
      codigoExterno: searchData.codigoExterno,
      idLcProducto: searchData.idLcProducto,
      idLcPresentacion: searchData.idLcPresentacion,
      idLcCurva: searchData.idLcCurva,
      idLcDiametro: searchData.idLcDiametro,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getLentesContacto(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (parItem, parAction) => {
    if (parAction !== "new") {
      navigate("/articulo/lente-contacto/" + parItem.id + "/" + parAction);
    } else {
      navigate("/articulo/lente-contacto/new/" + parAction);
    }
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadLcPresentaciones = async () => {
    const response = await getCacheData("lc_presentacion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcPresentaciones(_var);
    } else {
      setLcPresentaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCurvas = async () => {
    const response = await getCacheData("lc_curva")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCurvas(_var);
    } else {
      setBlCurvas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcDiametros = async () => {
    const response = await getCacheData("lc_diametro")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setLcDiametros(_var);
    } else {
      setLcDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLentesContactoProductos = async () => {
    const response = await getCacheData("lente_contacto_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLentesContactoProductos(_var);
    } else {
      setLentesContactoProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={searchData.codigo}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={searchData.descripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-bl-producto"
                  size="small"
                  value={
                    valueACLenteContactoProducto && valueACLenteContactoProducto.id
                      ? valueACLenteContactoProducto
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLenteContactoProducto(newValue);
                    setSearchData({
                      ...searchData,
                      idLcProducto: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputvalueACLenteContactoProducto}
                  onInputChange={(event, newInputValue) => {
                    setInputvalueACLenteContactoProducto(newInputValue);
                  }}
                  options={LentesContactoProductos}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Producto" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-lc-presentacion"
                  size="small"
                  value={
                    valueACLcPresentacion && valueACLcPresentacion.id
                      ? valueACLcPresentacion
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcPresentacion(newValue);
                    setSearchData({
                      ...searchData,
                      idLcPresentacion: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcPresentacion}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcPresentacion(newInputValue);
                  }}
                  options={lcPresentaciones}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Presentación" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-lc-curva"
                  size="small"
                  value={
                    valueACBlCurva && valueACBlCurva.id
                      ? valueACBlCurva
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCurva(newValue);
                    setSearchData({
                      ...searchData,
                      idLcCurva: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCurva}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCurva(newInputValue);
                  }}
                  options={blCurvas}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="Curva" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-lc-diametro"
                  size="small"
                  value={
                    valueACLcDiametro && valueACLcDiametro.id
                      ? valueACLcDiametro
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcDiametro(newValue);
                    setSearchData({
                      ...searchData,
                      idLcDiametro: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcDiametro}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcDiametro(newInputValue);
                  }}
                  options={lcDiametros}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="Diámetro" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="modelo"
                  label="Modelo"
                  variant="outlined"
                  size="small"
                  name="modelo"
                  value={searchData.modelo}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoExterno"
                  label="Código Externo"
                  variant="outlined"
                  size="small"
                  name="codigoExterno"
                  value={searchData.codigoExterno}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="id-estado">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearLenteContacto && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo lente de contacto">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default LenteContactoTable;
